@if (staff()) {
  @if (type==='wf') {
    <a rel="noopener noreferrer" class="cl-a-external" [href]="'https://us-east-1.console.aws.amazon.com/states/home?region=us-east-1#/v2/executions/details/arn:aws:states:us-east-1:' + environment.accountId + ':execution:workflow-api-' + environment.env_name + '-API-Processes:' + processId ">{{ processId }}</a>
  }
  @if (type==='cr') {
    <a rel="noopener noreferrer" class="cl-a-external" [href]="'https://us-east-1.console.aws.amazon.com/states/home?region=us-east-1#/v2/executions/details/arn:aws:states:us-east-1:' + environment.accountId + ':execution:content-api-' + environment.env_name + '-API-Processes:' + processId ">{{ processId }}</a>
  }
} @else {
  {{ processId }}
}
